var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteLabel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 200,
    viewBox: "0 0 197 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1102_16190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.5 195.269C152.422 195.269 196.134 151.556 196.134 97.6344C196.134 43.7124 152.422 0 98.5 0C44.578 0 0.865601 43.7124 0.865601 97.6344C0.865601 151.556 44.578 195.269 98.5 195.269Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4408 77.2442C89.4408 77.2442 86.7032 69.2415 88.1969 55.7635C88.9012 49.3909 91.2242 45.1651 96.069 42.5297C110.189 34.8508 128.176 44.955 122.747 57.9956L99.1247 56.3939L89.4408 77.2385V77.2442Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4408 77.2442L83.6759 97.8275C83.6759 97.8275 89.6623 109.107 104.543 104.024C108.138 102.797 108.457 98.5318 108.457 98.5318L106.503 89.3306",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4408 77.2442L83.6759 97.8275C83.6759 97.8275 89.6623 109.107 104.543 104.024C108.138 102.797 108.457 98.5318 108.457 98.5318L106.503 89.3306",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4902 148.985C32.4902 148.985 44.713 118.223 47.7516 111.697C50.0179 106.83 56.3053 101.729 61.9453 100.253C68.3122 98.5829 83.6759 97.8332 83.6759 97.8332C83.6759 97.8332 96.0633 112.612 108.456 98.5318C108.456 98.5318 117.919 99.2247 128.222 101.258C138.156 103.218 148.754 102.104 157.813 149.189L145.199 153.92L134.873 199.79H63.8139L57.2481 152.983L32.4959 148.985H32.4902Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.246 193.508C139.246 193.508 148.749 191.997 155.695 188.692C159.443 186.908 160.381 185.596 160.097 182.166C159.716 177.542 154.519 150.416 154.519 150.416L147.141 153.915L140.183 177.571L139.246 193.508Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.747 58.0013C122.747 58.0013 117.601 78.3347 112.961 86.0023C110.672 89.785 106.986 89.3363 105.583 89.2795C101.192 89.0978 96.3304 86.9508 89.4409 77.2442L91.6162 69.3551C91.6162 69.3551 89.9236 70.0594 89.3443 68.3157C88.765 66.572 89.9804 60.4436 91.4458 59.8927C93.4791 59.1316 93.7347 60.6935 93.712 62.0339L95.0808 57.7003C96.0521 54.9286 96.5973 50.7937 98.1933 50.3166C99.2668 49.9986 119.259 49.3341 122.741 58.0013H122.747Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.867 74.0295L107.934 74.6883C108.332 74.8133 108.758 74.6031 108.888 74.2055C109.428 72.5868 110.802 67.2536 111.825 63.2607",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.867 74.0295L107.934 74.6883C108.332 74.8133 108.758 74.6031 108.888 74.2055C109.428 72.5868 110.802 67.2536 111.825 63.2607",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.929 64.8056C105.537 64.8397 105.185 64.55 105.151 64.1581C105.117 63.7662 105.407 63.4141 105.798 63.38C106.19 63.3459 106.542 63.6356 106.577 64.0275C106.611 64.4194 106.321 64.7715 105.929 64.8056Z",
    fill: "#1F2025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.892 67.2876C114.5 67.3217 114.148 67.0321 114.114 66.6402C114.079 66.2483 114.369 65.8961 114.761 65.862C115.153 65.828 115.505 66.1176 115.539 66.5095C115.573 66.9014 115.284 67.2536 114.892 67.2876Z",
    fill: "#1F2025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.147 86.5589C131.596 86.61 131.107 86.2011 131.056 85.6502C131.005 85.0992 131.414 84.6108 131.965 84.5597C132.516 84.5086 133.004 84.9175 133.055 85.4684C133.107 86.0194 132.698 86.5078 132.147 86.5589Z",
    fill: "#1F2025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.873 199.784H83.2614L103.652 133.32H155.269L134.873 199.784Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3528 128.545L88.1484 127.383L85.7684 135.995L89.9728 137.157L92.3528 128.545Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9765 164.848L75.5823 162.253L83.8633 131.628L93.2576 134.223L84.9765 164.848Z",
    fill: "#1F2025",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0865 129.163C104.732 129.163 112.552 121.343 112.552 111.697C112.552 102.052 104.732 94.2322 95.0865 94.2322C85.4407 94.2322 77.6213 102.052 77.6213 111.697C77.6213 121.343 85.4407 129.163 95.0865 129.163Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0864 125.687C102.812 125.687 109.076 119.423 109.076 111.697C109.076 103.971 102.812 97.7082 95.0864 97.7082C87.3604 97.7082 81.0973 103.971 81.0973 111.697C81.0973 119.423 87.3604 125.687 95.0864 125.687Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.384 185.676C121.384 185.676 118.567 185.488 118.862 187.436C118.896 187.681 119.1 188.641 120.679 188.731C122.258 188.822 133.703 189.725 133.703 189.725L123.002 189.703C122.111 189.725 121.372 190.503 121.497 191.39C121.497 191.401 121.497 191.418 121.503 191.429C121.622 192.179 122.077 192.696 124.235 192.792C133.01 193.19 133.669 193.559 138.167 193.769C142.279 193.962 143.961 182.058 142.206 181.132C139.155 179.519 137.719 179.036 135.583 178.485C132.249 177.628 130.522 176.827 125.626 175.997C123.894 175.702 122.378 175.685 121.861 176.906C121.531 177.679 121.73 178.587 123.065 179.025C124.127 179.371 132.84 181.899 132.84 181.899L119.947 180.695C119.947 180.695 117.885 180.496 117.556 182.092C117.357 183.069 117.737 184.205 119.339 184.279C122.917 184.449 132.811 185.755 132.811 185.755L121.372 185.681L121.384 185.676Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3992 145.049C96.4836 144.77 97.9149 140.67 93.8255 139.437C88.0038 137.682 79.683 136.955 76.7693 137.96C72.5379 139.42 63.7628 147.57 57.2992 154.522L46.3942 165.416L58.4352 153.335L36.1991 149.587C36.1991 149.587 28.0373 173.51 27.458 187.647C27.2762 192.082 40.7542 196.615 45.1674 193.519C57.6514 184.761 73.8386 159.611 78.0529 157.43C78.0643 157.425 78.0757 157.419 78.087 157.413C79.7057 156.59 81.5687 156.385 83.3521 156.698C85.5161 157.078 87.9754 157.448 89.685 157.476C93.1496 157.533 92.1557 154.011 92.1557 154.011C96.1712 152.932 93.6495 149.445 93.6495 149.445C97.7445 148.201 94.3992 145.054 94.3992 145.054V145.049Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.367 67.1286C135.946 64.2206 139.65 63.1982 142.506 64.9476C145.011 66.4811 145.977 69.7299 144.71 72.3823C143.767 74.3646 141.87 75.5516 139.854 75.6879C137.622 75.8413 135.594 77.0397 134.526 79.0106",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1617 71.4111C91.1617 71.4111 96.6995 76.8693 97.7729 77.6361C98.8464 78.4029 100.42 76.6365 102.589 76.6365C104.759 76.6365 109.871 78.1984 110.405 79.0049C110.745 79.5218 110.956 80.5782 111.058 81.2654C111.109 81.6006 111.455 81.805 111.773 81.6858L115.721 80.2431",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1617 71.4111C91.1617 71.4111 96.6995 76.8693 97.7729 77.6361C98.8464 78.4029 100.42 76.6365 102.589 76.6365C104.759 76.6365 109.871 78.1984 110.405 79.0049C110.745 79.5218 110.956 80.5782 111.058 81.2654C111.109 81.6006 111.455 81.805 111.773 81.6857L115.721 80.2431",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.589 81.1405C102.589 81.1405 105.503 82.4582 106.503 82.6967L102.589 81.1405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.589 81.1405C102.589 81.1405 105.503 82.4582 106.503 82.6967",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.718 76.5683C92.718 76.5683 92.8714 77.9031 92.9679 78.153L92.718 76.5683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.718 76.5683C92.718 76.5683 92.8714 77.9031 92.9679 78.153",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8252 79.6183C94.8252 79.6183 96.1656 79.5786 96.4269 79.4934L94.8252 79.6183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8252 79.6183C94.8252 79.6183 96.1656 79.5786 96.4269 79.4934",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5007 82.3616C96.5007 82.3616 97.6935 82.975 97.9604 83.0318L96.5007 82.3616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5007 82.3616C96.5007 82.3616 97.6935 82.975 97.9604 83.0318",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1929 79.6467C99.1929 79.6467 99.7438 80.8736 99.9199 81.078L99.1929 79.6467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1929 79.6467C99.1929 79.6467 99.7438 80.8736 99.9199 81.078",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.261 83.8554C100.261 83.8554 101.067 83.7645 101.22 83.702L100.261 83.8554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.261 83.8554C100.261 83.8554 101.067 83.7645 101.22 83.702",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6483 80.4305C96.6483 80.4305 97.1765 81.0496 97.3128 81.1405L96.6483 80.4305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6483 80.4305C96.6483 80.4305 97.1765 81.0496 97.3128 81.1405",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7513 77.1192C94.7513 77.1192 95.2796 77.7383 95.4159 77.8292L94.7513 77.1192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7513 77.1192C94.7513 77.1192 95.2796 77.7383 95.4159 77.8292",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3091 74.3248C92.3091 74.3248 92.4 75.1314 92.4624 75.2847L92.3091 74.3248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3091 74.3248C92.3091 74.3248 92.4 75.1314 92.4624 75.2847",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0425 76.432C91.0425 76.432 91.3378 77.1874 91.4344 77.3237L91.0425 76.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0425 76.432C91.0425 76.432 91.3378 77.1874 91.4344 77.3237",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9679 79.4423C92.9679 79.4423 93.2632 80.1977 93.3598 80.334L92.9679 79.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9679 79.4423C92.9679 79.4423 93.2632 80.1977 93.3598 80.334",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.419 83.3726C103.419 83.3726 103.419 84.1848 103.458 84.3439L103.419 83.3726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.419 83.3726C103.419 83.3726 103.419 84.1848 103.458 84.3439",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.895 86.5646C104.895 86.5646 104.282 87.0985 104.191 87.2348L104.895 86.5646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.895 86.5646C104.895 86.5646 104.282 87.0985 104.191 87.2348",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.854 87.2405C107.854 87.2405 108.61 86.9395 108.741 86.8372L107.854 87.2405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.854 87.2405C107.854 87.2405 108.61 86.9395 108.741 86.8372",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.593 84.3893C108.593 84.3893 109.081 85.0368 109.212 85.139L108.593 84.3893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.593 84.3893C108.593 84.3893 109.081 85.0368 109.212 85.139",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.222 83.5998C112.222 83.5998 112.796 83.0205 112.875 82.8785L112.222 83.5998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.222 83.5998C112.222 83.5998 112.796 83.0205 112.875 82.8785",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.053 82.7251C109.053 82.7251 109.627 82.1458 109.706 82.0038L109.053 82.7251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.053 82.7251C109.053 82.7251 109.627 82.1458 109.706 82.0038",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.679 79.6467C105.679 79.6467 106.412 79.2946 106.537 79.1867L105.679 79.6467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.679 79.6467C105.679 79.6467 106.412 79.2946 106.537 79.1867",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.469 84.8607C104.469 84.8607 105.202 84.5086 105.327 84.4007L104.469 84.8607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.469 84.8607C104.469 84.8607 105.202 84.5086 105.327 84.4007",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1251 84.6335C98.1251 84.6335 98.8578 84.2814 98.9828 84.1735L98.1251 84.6335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1251 84.6335C98.1251 84.6335 98.8578 84.2814 98.9828 84.1735",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.598 81.4018C94.598 81.4018 95.4102 81.3847 95.5693 81.3393L94.598 81.4018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.598 81.4018C94.598 81.4018 95.4102 81.3847 95.5693 81.3393",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.567 82.3957C100.567 82.3957 101.38 82.3787 101.539 82.3332L100.567 82.3957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.567 82.3957C100.567 82.3957 101.38 82.3787 101.539 82.3332",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.351 78.9765C101.351 78.9765 100.88 78.3177 100.749 78.2098L101.351 78.9765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.351 78.9765C101.351 78.9765 100.88 78.3177 100.749 78.2098",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.056 85.5877C101.056 85.5877 102.396 85.6104 102.663 85.5423L101.056 85.5877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.056 85.5877C101.056 85.5877 102.396 85.6104 102.663 85.5423",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.162 85.0254C106.162 85.0254 107.156 85.9285 107.394 86.0534L106.162 85.0254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.162 85.0254C106.162 85.0254 107.156 85.9285 107.394 86.0534",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.728 85.3435C110.728 85.3435 111.098 84.0542 111.098 83.7816L110.728 85.3435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.728 85.3435C110.728 85.3435 111.098 84.0542 111.098 83.7816",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.945 80.3283C107.945 80.3283 109.28 80.5044 109.547 80.4646L107.945 80.3283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.945 80.3283C107.945 80.3283 109.28 80.5044 109.547 80.4646",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.76 78.1643C102.76 78.1643 103.867 78.9254 104.123 79.0163L102.76 78.1643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.76 78.1643C102.76 78.1643 103.867 78.9254 104.123 79.0163",
    stroke: "#1F2025",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1102_16190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195.269,
    height: 200,
    fill: "white",
    transform: "translate(0.865601)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLabel);
export default __webpack_public_path__ + "static/media/white_label.33d7e72d7186677c76f75608e79c2053.svg";
export { ForwardRef as ReactComponent };